// Security fix applied - credentials removed from Login component
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { UpdateNotification } from '@/components/UpdateNotification';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Batches from './components/Batches';
import BatchDetail from './components/BatchDetail';
import BankStatements from './components/BankStatements';
import Activity from './components/Activity';
import Companies from './components/Companies';
import CompanyDetail from './components/CompanyDetail';
import Suppliers from './components/Suppliers';
import SupplierDetail from './components/SupplierDetail';
import NominalCodes from './components/NominalCodes';
import Knowledge from './components/Knowledge';
import Admin from './components/Admin';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <UpdateNotification />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="batches" element={<Batches />} />
            <Route path="batches/:batchId" element={<BatchDetail />} />
            <Route path="bank-statements" element={<BankStatements />} />
            <Route path="activity" element={<Activity />} />
            <Route path="companies" element={<Companies />} />
            <Route path="companies/:companyId" element={<CompanyDetail />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="suppliers/:supplierId" element={<SupplierDetail />} />
            <Route path="nominal-codes" element={<NominalCodes />} />
            <Route path="knowledge" element={<Knowledge />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
